import React, { useMemo } from 'react';
import { ButtonGroup, Card, CardHeader, CardBody, Row, Col} from "reactstrap";
import { useTranslation } from 'react-i18next';
import ApiError from 'components/common/ApiError.js';
import { DIAGRAMS } from 'constants/diagrams.js';
import {DiagramButton, DiagramBody, DiagramHeader} from './DiagramButton';
import { API_ENDPOINTS } from 'constants/apiEndpoints.js';
import { getMonthLabel } from 'utils/index.js';
import useHistogramData from 'hooks/useHistogramData';

const Histogram = () => {
    const { t, i18n } = useTranslation();

    const processDataForChart = (data, category) => {
        const categoryMap = {
            [DIAGRAMS.EMAILS.RECEIVED]: 'emails_received',
            [DIAGRAMS.EMAILS.SUGGESTED]: 'emails_suggested',
            [DIAGRAMS.EMAILS.SENT]: 'emails_sent',
        };

        const chartData = data?.[categoryMap[category]] || [];

        return chartData?.reduce((acc, item) => ({
            ...acc,
            labels: [ ...acc.labels, getMonthLabel(item.date, i18n.language)],
            dataEdited: [...acc.dataEdited, item.emailsCount],
        }), { labels: [], dataEdited: [] });
    };

    const { chartData, isLoading, error, refetch, category, setCategory, gradientStroke} = useHistogramData(API_ENDPOINTS.REPORTS.EMAILS, DIAGRAMS.EMAILS.RECEIVED, processDataForChart)
    
    const formattedChartData = useMemo(() => ({
        labels: chartData.labels,
        datasets: [{
            label: t(`diagrams.data.${category}`),
            fill: true,
            backgroundColor: gradientStroke,
            borderColor: "#1f8ef1",
            borderWidth: 2,
            pointBackgroundColor: "#1f8ef1",
            data: chartData.dataEdited,
        }],
    }), [chartData, category, gradientStroke, t]);

    if(error) return <ApiError retryFetch={refetch} errorMessage={error.message}/>
    return (
        <Card className="card-chart">
            <CardHeader>
                <Row>
                    <DiagramHeader headerText={t('diagrams.title.emails')} title={t('diagrams.title.emails')} icon="tim-icons icon-email-85"/>
                    <Col xl="8" lg="6">
                        <ButtonGroup className="btn-group-toggle float-right" data-toggle="buttons">
                            <DiagramButton id="0" category={category} setCategory ={setCategory} buttonCategory={DIAGRAMS.EMAILS.RECEIVED} label={t('diagrams.label.received')} icon={"tim-icons icon-single-02"}/>
                            <DiagramButton id="1" category={category} setCategory ={setCategory} buttonCategory={DIAGRAMS.EMAILS.SUGGESTED} label={t('diagrams.label.suggested')} icon={"tim-icons icon-gift-2"}/>
                            <DiagramButton id="2" category={category} setCategory ={setCategory} buttonCategory={DIAGRAMS.EMAILS.SENT} label={t('diagrams.label.sent')} icon={"tim-icons icon-tap-02"}/>
                        </ButtonGroup>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <DiagramBody chartData={formattedChartData} isLoading={isLoading}/>
            </CardBody>
        </Card>
    );
};

export default Histogram;